var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPadlockDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99916 0C5.61199 0 3.43018 1.56078 3.43018 4.76863V6.54902C2.43766 6.67451 1.94141 7.26275 1.94141 8.37647V14.1412C1.94141 15.4196 2.58312 16 3.86654 16H12.1318C13.4152 16 14.0569 15.4196 14.0569 14.1412V8.37647C14.0569 7.26275 13.5607 6.67451 12.5681 6.54902V4.76863C12.5681 1.56078 10.3863 0 7.99916 0ZM4.80758 4.59608C4.80758 2.40784 6.2279 1.20784 7.99903 1.20784C9.76159 1.20784 11.1905 2.40784 11.1905 4.59608V6.51765H4.80758V4.59608ZM12.0894 7.7019C12.4915 7.7019 12.6798 7.85877 12.6798 8.29014V14.2196C12.6798 14.6588 12.4915 14.8235 12.0894 14.8235H3.90971C3.51613 14.8235 3.31934 14.6588 3.31934 14.2196V8.29014C3.31934 7.85877 3.51613 7.7019 3.90971 7.7019H12.0894Z",
    fill: "#414141"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPadlockDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PadlockDark.9adf8edc2e25f200dd4cc057d451fd61.svg";